<template>
    <div class="articleDetail">
        <div class="title">
            <div class="title-text">{{item.title}}
                <el-button class="back-btn" size="mini" @click="back">{{$t('back')}}</el-button>
            </div>
            <el-divider></el-divider>
        </div>
        <div class="content">
            <div class="content-crt">{{$t('ReleaseTime')}}: {{item.crtTime}}</div>
            <div v-html="item.content"></div>
        </div>
    </div>
</template>
<script>
import { getLatestAnnouncement } from '@/api/buyTicket'
import { config } from '@/constant/config'
export default {
  name: 'articleDetail',
  data () {
    return {
      item: null
    }
  },
  created () {
    this.item = JSON.parse(this.$route.query.item)
    this.item.content = this.item.content ? this.item.content.replace('<img class="wscnph" src="', '<img class="wscnph" src="' + config.BASE_URL + '/') : ''
    if (this.item.content) {
      const regExp = new RegExp('<img src="file/download/', 'g')
      this.item.content = this.item.content.replace(regExp, `<img src="${config.BASE_URL}/file/download/`)
      this.item.content = this.item.content.replace(/\<img/gi, '<img style="max-width:96%;display:block;height:auto;margin:0 2%;"')
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.articleDetail {
    width: 1100px;
    margin: 0 auto;
    background-color: white;
    min-height: 520px;
    padding: 30px 90px;
    margin-bottom: 100px;
    .title {
        .title-text {
            position: relative;
            text-align: center;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 31px;
            color: #424855;
            opacity: 1;
            .back-btn {
                position: absolute;
                right: 0;
            }
        }
    }
    .content {
        .content-crt {
            text-align: center;
            margin-bottom: 40px;
        }
    }
}
</style>
